import {
    useContext,
    useEffect,
    useState
} from 'react';
import { useRouter } from "next/router";

import {
    Button
} from '@mui/material';

import { RequestNextApi } from '../../../../api/Request';
import Header from '../../../../components/Header';
import Layout from '../../../../components/Layout';
import Navigation, { eventsNavigation } from '../../../../navigation/events/navigation';
import { headerLink } from '../../../../navigation/function';
import DashboardTicket from '../../../../components/AnnualConference/Registration/Dashboard/DashboardTicket';
import { ProgressContext } from '../../../../components/Context/progressContext';
import { PurchaseTicketContext } from '../../../../components/Context/ticketContext';
import { getCookie } from '../../../../utils/cookieHandle';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';

export default function Dashboard(props) {
    const { state: purchaseTicketContext, update: updatePurchaseTicket } = useContext(PurchaseTicketContext);
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const [allTickets, setAllTickets] = useState();
    const [othersTicket, setOthersTicket] = useState([]);
    const [myTicket, setMyTicket] = useState([]);

    const router = useRouter();

    useEffect(() => {
        const initPage = async () => {
            updateProgress({ isLoading: true });
            try {
                const res = await RequestNextApi.post('/events/registration/dashboard',
                    {
                        jwtToken: getCookie('jwt-token')
                    }
                );
                if (res.data && res.data.success) {
                    setAllTickets(res.data.results);
                } else {
                    ShowNotification.error(res.data.message);
                }
            } catch (error) {
                ShowNotification.error('Something went wrong!');
            }
            updateProgress({ isLoading: false });
        };
        initPage();
    }, []);

    useEffect(() => {
        if (allTickets) {
            // set others tickets
            let tickets = allTickets.filter((item) => item?.isPurchaserOfThisTicket && !item?.isAssignedToThisTicket);
            setOthersTicket(tickets);

            // set my tickets
            tickets = allTickets.filter((item) => item?.isAssignedToThisTicket);
            setMyTicket(tickets);
        }
    }, [allTickets]);

    const registrationLink = headerLink(eventsNavigation.registration);
    const currentLink = headerLink(eventsNavigation.dashboard, true);

    const handlePurchase = () => {
        updatePurchaseTicket({
            tickets: [],
            donationAmount: 0,
            purchaser: null,
            paymentMethod: null
        });
        router.push(eventsNavigation.registration.href);
    };

    const handleCancel = () => {
        // call cacel api
        router.push(eventsNavigation.cancel.href);
    };

    return (
        <Navigation>
            <Layout>
                <Header>
                    <div>Members | {registrationLink} | {currentLink}</div>
                </Header>
                <div className='mt-5'>
                    <div className='sub-title text-secondary-500'>
                        Conference Schedule
                    </div>
                </div>
                <div className='sub-title text-secondary-500 mt-8'>
                    Ticket Dashboard
                </div>
                <div>
                    <div className='mt-5 text-xl' style={{ fontWeight: 'bold' }}>
                        Your Ticket
                    </div>
                    <div className='text-xl mt-2'>
                        Your ticket is listed below. Teal indicates your event registration is complete. Red indicates your registration is not complete and you are not yet registered for the conference.
                    </div>
                    <div className='mt-5 space-y-5 mb-5'>
                        {myTicket.map((item, index) => (
                            <div className='dashboard-orange-wrapper p-5' key={index}>
                                <DashboardTicket ticket={item} />
                            </div>
                        ))}
                        {myTicket.length === 0 && (
                            <div className='dashboard-orange-wrapper p-5 text-xl text-red-400 font-bold'>
                                There is no ticket assigned to you.
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <div className='mt-8 text-xl' style={{ fontWeight: 'bold' }}>
                        Tickets Purchased for Others
                    </div>
                    <div className='text-xl mt-2'>
                        The ticket(s) you have purchased are listed below. Teal indicates a ticket holder&apos;s event registration is complete. Red indicates a ticket holder&apos;s event registration is not complete and that person is not yet registered for the conference.
                    </div>
                    <div className='mt-5 space-y-5 mb-5'>
                        {othersTicket.map((item, index) => (
                            <div className='dashboard-orange-wrapper p-5' key={index}>
                                <DashboardTicket ticket={item} />
                            </div>
                        ))}
                        {othersTicket.length === 0 && (
                            <div className='dashboard-orange-wrapper p-5 text-xl text-red-400 font-bold'>
                                You have not purchased a ticket for others.
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex flex-col space-y-3 mb-8'>
                    <Button
                        variant="contained"
                        className='bg-secondary-500 hover:bg-secondary-500 w-fit'
                        onClick={handlePurchase}
                    >
                        Purchase Additional Tickets
                    </Button>
                    <Button
                        variant="contained"
                        className='bg-secondary-500 hover:bg-secondary-500 w-fit'
                        onClick={handleCancel}
                    >
                        Cancel Tickets
                    </Button>
                </div>
                {/* <FreshChat/> */}
            </Layout>
        </Navigation>
    )
}

Dashboard.getLayout = page => <>{page}</>;
